import { configureStore } from "@reduxjs/toolkit";
import userVocabularyReducer from "./slices/userVocabularySlice";
import searchReducer from "./slices/searchSlice";
import sidebarReducer from "./slices/sidebarSlice";
import authReducer from "./slices/authSlice";
import themeReducer from "./slices/themeSlice";
import userReducer from "./slices/userSlice";
import exerciseReducer from "./slices/exerciseSlice";
import setsReducer from "./slices/wordSetsSlice";

// Only apply redux-immutable-state-invariant in development mode
const getMiddleware = () => {
  const middleware = [];
  if (process.env.NODE_ENV !== "production") {
    const reduxImmutableStateInvariant =
      require("redux-immutable-state-invariant").default();
    middleware.push(reduxImmutableStateInvariant);
  }
  return middleware;
};

export default configureStore({
  reducer: {
    userVocabulary: userVocabularyReducer,
    search: searchReducer,
    sidebar: sidebarReducer,
    auth: authReducer,
    theme: themeReducer,
    user: userReducer,
    exercise: exerciseReducer,
    sets: setsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(getMiddleware()),
});
